<template>
  <div class="contentBox">
    <div class="logo-item clear">
      <div class="logo-txt">
        <i class="icon icon-logo"></i>
        <p>Speakio</p>
      </div>
      <div class="logo-nav">
        <button class="btn btn-nav btn-nav1">
          <router-link router-link to="/index">Features</router-link>
        </button>
        <button class="btn btn-nav btn-nav2 select">
          <router-link router-link to="/contact">Contact</router-link>
        </button>
      </div>
    </div>
    <div class="email">
      <p>Contact</p>
      <span>zentimewise@163.com</span>
    </div>
  </div>
</template>

<script>

export default {
  name: "index",
  data() {
    return {
      
    };
  },
  mounted(){
    
  },
  methods: {
    
  }
};
</script>
<style scoped>
  .contentBox{
    background-image: url(~@/assets/images/index-icon11.png);
    width: 100%;
    height: 100%;
    background-size: 100% 100%;
  }

  .logo-item{
    display: block;
    box-sizing: border-box;
    padding: 10px 100px;
    background-color: rgba(255, 255, 255, .43);
  }

  .logo-item .logo-txt{
    float: left;
  }

  .logo-item .logo-txt .icon-logo{
    background-image: url(~@/assets/images/index-icon10.png);
    width: 60px;
    height: 60px;
    background-size: 60px 60px;
    display: inline-block;
    vertical-align: middle;
  }

  .logo-item .logo-txt p{
    font-size: 18px;
    color: #000000;
    display: inline-block;
    vertical-align: middle;
    margin-left: 10px;
  }

  .logo-item .logo-nav{
    float: right;
  }

  .logo-item .logo-nav .btn{
    font-size: 18px;
    color: #333333;
    display: inline-block;
    vertical-align: top;
    box-sizing: border-box;
    padding: 15px 0;
  }

  .logo-item .logo-nav a{
    text-decoration: none;
    color: #333333;
  }

  .logo-item .logo-nav .btn.select{
    color: #6E2FFF;
    border-bottom: solid 3px #6E2FFF;
  }

  .logo-item .logo-nav .btn.btn-nav2{
    margin-left: 50px;
  }

  .email{
    position: fixed;
    top: 50%;
    left: 50%;
    box-sizing: border-box;
    padding: 56px 130px;
    background-color: #fff;
    transform: translate(-50%, -50%);
    border-radius: 40px;
    text-align: center;
  }

  .email p{
    color: #000000;
    font-size: 48px;
  }

  .email span{
    color: #000000;
    font-size: 24px;
    margin-top: 60px;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/index/contact.vue